import { CUSTOM_ATTRIBUTE_VALUE_FRAGMENT } from "@gql/fragments/product/customAttributeValueFragment";
import gql from "graphql-tag";

// note - custom_attribute_value is a graphql alias configured in hasura for brevity
export const ADD_CUSTOM_ATTRIBUTE_VALUE_MANY = gql`
  mutation AddCustomAttributeValueMany($objects: [custom_attribute_value_insert_input!]!) {
    insert_custom_attribute_value(objects: $objects) {
      returning {
        ...customAttributeValueFields
      }
    }
  }

  ${CUSTOM_ATTRIBUTE_VALUE_FRAGMENT}
`;
